// extracted by mini-css-extract-plugin
export default {"harvestForc":"footer_harvestForc__wwv3n","socialIcons":"footer_socialIcons__Ve+aG","links":"footer_links__yBF6u"};